import React, { useEffect, useRef } from "react";
import "./BrokenBranding.css";

import ClockIcon from "../../assets/BrandingBrokenBox/Clock.png";
import BrainIcon from "../../assets/BrandingBrokenBox/Brain.png";
import CupIcon from "../../assets/BrandingBrokenBox/Cup.png";
import LeftBrokenPost from "../../assets/LandingPageGraphics/LeftBrokenPost.png";
import RightBrokenPost from "../../assets/LandingPageGraphics/RightBrokenPost.png";

const BrokenBranding = () => {
  const leftGraphicRef = useRef(null);
  const rightGraphicRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    // Capture the current ref values
    const leftGraphic = leftGraphicRef.current;
    const rightGraphic = rightGraphicRef.current;

    if (leftGraphic) observer.observe(leftGraphic);
    if (rightGraphic) observer.observe(rightGraphic);

    return () => {
      if (leftGraphic) observer.unobserve(leftGraphic);
      if (rightGraphic) observer.unobserve(rightGraphic);
    };
  }, []);

  return (
    <section className="broken-branding-section">
      <h2 className="broken-branding-heading">
        Personal Branding is <span className="broken-text">Broken</span>
      </h2>
      <p className="broken-subtext">Most people avoid it because it’s:</p>

      <img
        src={LeftBrokenPost}
        alt="Left Graphic"
        className="left-broken-graphic"
        ref={leftGraphicRef}
      />
      <img
        src={RightBrokenPost}
        alt="Right Graphic"
        className="right-broken-graphic"
        ref={rightGraphicRef}
      />

      <div className="broken-card">
        <div className="broken-item">
          <img src={ClockIcon} alt="Clock Icon" className="broken-icon" />
          <h4 className="broken-title">TIME CONSUMING</h4>
          <p className="broken-description">Hours of content creation</p>
        </div>
        <div className="broken-item">
          <img src={BrainIcon} alt="Brain Icon" className="broken-icon" />
          <h4 className="broken-title">HARD</h4>
          <p className="broken-description">Complex strategies to learn</p>
        </div>
        <div className="broken-item">
          <img src={CupIcon} alt="Cup Icon" className="broken-icon" />
          <h4 className="broken-title">BORING</h4>
          <p className="broken-description">Repetitive &<br />draining tasks</p>
        </div>
      </div>
    </section>
  );
};

export default BrokenBranding;
